module.exports = {"title":"POS Settings","datatable":{"code":"Site ID","name":"Station Name"}};